// Permission levels matching backend env.config.js
export const PERMISSION_LEVELS = {
    NORMAL_USER: 1,
    PAID_USER: 4,
    ADMIN: 2048
};

// Export individual permission levels for convenience
export const ADMIN_PERMISSION_LEVEL = PERMISSION_LEVELS.ADMIN;

